import {
  Paper,
  Typography,
  Stack,
  Box,
  Link,
  useTheme,
  Tooltip,
  Button,
  alpha,
  darken,
  lighten,
  Divider,
} from "@mui/material";

import ReportProblemOutlinedIcon from "@mui/icons-material/ReportProblemOutlined";
import LinkOutlinedIcon from "@mui/icons-material/LinkOutlined";
import { useEffect, useState } from "react";
import IconTransform from "../../iconsElement";
import { Home, HomeOutlined, ReportProblem } from "@mui/icons-material";
import { useOutletContext } from "react-router-dom";

export default function CardCTOS(props) {
  const { cto, search = () => {}, iconsElements = [], onus } = props;
  const [alertCount, setAlertCount] = useState(0);
  const { config } = useOutletContext();

  useEffect(() => {
    if (!cto) return;

    const filteredOnus = onus.filter(
      (onu) =>
        cto.onus.includes(onu.id) &&
        onu.cto?.trim().toLowerCase() === cto.titulo?.trim().toLowerCase()
    );
    setAlertCount(filteredOnus.flatMap((client) => client.alerts)?.length);
  }, [cto, onus]);

  const theme = useTheme();

  function colorEnlace(power) {
    if (power == null || power == 0 || power === Infinity || !config) {
      return theme.palette.enlaces.offline.main;
    }
    const result = config?.configuracoes?.ftth?.camadaFTTH?.escala
      .filter((scale) => parseFloat(scale?.label) >= power)
      .pop();

    if (!result) return theme.palette.enlaces.offline.main;
    return result?.cor;
  }

  const SvgMenu = ({ selected, sx }) => {
    return (
      <svg
        style={sx}
        width="190"
        height="40"
        viewBox="0 0 163 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M0 0.50119H127.163L163 22.5012H157.798L126.007 2.5477H0V0.50119Z"
          fill={theme.palette.color.iconsDisable}
        />{" "}
        {/* Primeiro path */}
        <path
          d="M146.799 21.8481L120 4.50119H124.937L157.377 24.9094L163 24.8261L160.904 29.5012H154.556L146.799 24.9094V21.8481Z"
          fill={
            colorEnlace(cto?.data?.potencia?.rx) ?? theme.palette.primary.main
          }
        />{" "}
        {/* Segundo path */}
      </svg>
    );
  };

  const styles = {
    iconLinked: {
      transform: "rotate(90deg)",
      fontSize: "30px",
    },
    icon: {
      pointerEvents: "none",
      marginBottom: "-32px",
    },
    title: {
      fontSize: "1em",
      maxWidth: "150px",
      overflow: "hidden",
      textAlign: "left",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
    },

    subTitle: {
      fontSize: "12px",
      textDecoration: "none",
      textTransform: "none",
    },
    line: {
      backgroundColor: "primary.main",
      height: "60px",
      width: "3px",
    },
    alertTooltip: {
      mt: "5px",
      fontSize: "1.1em",
      maxWidth: "100%",
      textAlign: "left",
      whiteSpace: "wrap",
    },

    cardlinked: {
      width: "100%",
      backgroundColor: theme.palette.background.paperSelectedMaps,
      boxShadow: "0px 0px 5px  #0000001a",
      position: "relative",
      padding: "0px 15px",
      display: "flex",
      direction: "row",
      height: "100px",
      alignItems: "center",
      gap: 2,
      "&:hover": {
        backgroundColor: theme.palette.background.hover,
      },
    },
    cardType: {
      gap: 0.2,
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "center",
      position: "absolute",
      right: 4,
      top: 5,
      backgroundColor: alpha(theme.palette.color.alerts.warning, 0.2),
      color:
        theme.palette.mode != "dark"
          ? darken(theme.palette.color.alerts.warning, 0.2)
          : lighten(theme.palette.color.alerts.warning, 0.1),

      //width: "80px",
      p: "3px 5px",
      fontSize: "0.8em",
      borderRadius: "2px",

      textTransform: "none",
    },
  };
  const text = () => {
    let alert = !cto?.coordinateIsValid
      ? "A CTO não possui uma geolocalização cadastrada! Não é possível exibi-la no mapa."
      : null;
    return (
      <Box>
        <Typography
          sx={{ ...styles.title, fontSize: "1.1em", maxWidth: "100%" }}
        >
          {cto.titulo}
        </Typography>

        {alert && (
          <>
            <Divider />
            <Typography sx={styles.alertTooltip}>{alert}</Typography>
          </>
        )}
      </Box>
    );
  };

  return (
    <Tooltip title={text()} placement="left">
      <span style={{ display: "block" }}>
        <Button
          onClick={() => {
            search(cto.id);
          }}
          disabled={!cto.coordinateIsValid}
          sx={{
            padding: "0px",
            width: "97%",
          }}
        >
          <Paper
            elevation={0}
            sx={[
              styles.cardlinked,
              { opacity: !cto.coordinateIsValid ? 0.4 : 1 },
            ]}
          >
            <IconTransform
              img={iconsElements.find((a) => a.nome == "_cto")?.img}
              size={"30px"}
              color={theme.palette.color.icons}
            />

            <Stack direction={"column"}>
              <Stack direction="row" alignItems={"center"} gap={0.5}>
                <ReportProblem
                  sx={{
                    fontSize: "13px",
                    color: "primary.main",
                  }}
                />
                <Typography sx={styles.subTitle}>
                  {alertCount + " Alertas"}
                </Typography>
                <Home
                  sx={{
                    fontSize: "13px",
                    color: "primary.main",
                  }}
                />
                <Typography sx={styles.subTitle}>
                  {cto?.onus?.length + " ONUs"}
                </Typography>
              </Stack>
              <SvgMenu selected={true} sx={styles.icon} />

              <Typography sx={styles.title}>{cto.titulo}</Typography>
            </Stack>

            {/* <Box sx={styles.cardType}>
            <Typography
              sx={{ fontSize: "12px", fontWeight: 500, color: "white" }}
            >
              {"CTO"}
            </Typography>
          </Box> */}
          </Paper>
          {!cto?.coordinateIsValid && (
            <Stack sx={styles.cardType}>
              <ReportProblem sx={{ fontSize: "inherit" }} />
              <Typography fontSize={"inherit"} lineHeight={0}>
                {"Sem Coordenadas"}
              </Typography>
            </Stack>
          )}
        </Button>
      </span>
    </Tooltip>
  );
}
